import * as Yup from "yup";

export const ModalSchema = Yup.object({

    brand: Yup.string().required("Select Brand"),
    model: Yup.string().required("Enter Model Name"),
    status: Yup.string().required("Select Status"),
});